import {
  IComponentOptions,
  IController,
  INgModelController,
  IScope
} from 'angular';
import './gmc-from-to-picker.component.scss';
import { Moment } from 'moment';
import { cloneDeep } from 'lodash-es';
import * as moment from 'moment';

interface IFromToPicker {
  from: Moment;
  to: Moment;
}

class GmcFromToPickerController implements IController {
  static $inject = ['$scope'];

  from: Moment;
  fromClone: Moment;
  to: Moment;
  toClone: Moment;
  onSelect: (obj: IFromToPicker) => void;
  maxDate = moment();
  noMaxDate: boolean;
  disabled: boolean;

  constructor(private $scope: IScope) {}

  $onInit() {
    this.initData();
  }

  $onChanges() {
    this.initData();
  }

  getFromTo() {
    if (this.fromClone && this.toClone) {
      console.log(this.toClone.isBefore(this.fromClone));
      if (this.fromClone.isAfter(this.toClone)) {
        this.toClone = this.to;
        this.fromClone = this.from;
        return;
      } else if (this.toClone.isAfter(moment()) && !this.noMaxDate) {
        this.toClone = this.to;
        return;
      }
    } else if (this.fromClone && !this.toClone) {
      if (this.fromClone.isAfter(moment())) {
        return (this.fromClone = this.from);
      }
    } else if (this.toClone && !this.fromClone) {
      if (this.toClone.isAfter(moment()) && !this.noMaxDate) {
        return (this.toClone = this.to);
      }
    }
    this.onSelect({
      from: this.fromClone,
      to: this.disabled ? this.to : this.toClone
    });
  }

  initData() {
    this.fromClone = cloneDeep(this.from);
    this.$scope.$watch('$ctrl.disabled', (value) => {
      if (value) {
        return (this.toClone = undefined);
      }
      this.toClone = cloneDeep(this.to);
    });
  }
}

export const GmcFromToPickerComponent: IComponentOptions = {
  controller: GmcFromToPickerController,
  template: require('./gmc-from-to-picker.component.html'),
  bindings: {
    from: '<',
    to: '<',
    noMaxDate: '<',
    disabled: '<',
    onSelect: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-from-to-picker/gmc-from-to-picker.component.ts